export default __webpack_public_path__ + "static/media/quantum_16.149cce17.svg";